import { setShowClientSiteModal } from '../State/showClientSiteModal';
import { loadClientSiteForEdit } from '../State/clientSiteForEdit';

export default (record) => async (dispatch) => {
  
  dispatch(loadClientSiteForEdit(record));
  dispatch(setShowClientSiteModal(true))
    
}